// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
  if (typeof tns === 'undefined') return;

  const sliders = new Map(); // Store slider instances by container element
  const infoCardSliders = new Map(); // Store info-card slider instances separately
  const reviewSliders = new Map(); // Store industry-reviews slider instances separately
  const heightObservers = new Map(); // Store MutationObservers for height equalization

  function equalizeHeights(container) {
    requestAnimationFrame(function () {
      const items = container.querySelectorAll('.tns-item');
      if (!items.length) return;

      items.forEach(function (item) {
        item.style.height = 'auto';
      });

      requestAnimationFrame(function () {
        let maxHeight = 0;
        items.forEach(function (item) {
          const h = item.offsetHeight;
          if (h > maxHeight) maxHeight = h;
        });

        if (maxHeight > 0) {
          items.forEach(function (item) {
            item.style.height = maxHeight + 'px';
          });
        }
      });
    });
  }

  function setupHeightObserver(container) {
    // Disconnect existing observer if any
    if (heightObservers.has(container)) {
      heightObservers.get(container).disconnect();
    }

    // Create observer to watch for .tns-item elements being added
    const observer = new MutationObserver(function (mutations) {
      let hasNewItems = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList && node.classList.contains('tns-item')) {
              hasNewItems = true;
            } else if (node.querySelector && node.querySelector('.tns-item')) {
              hasNewItems = true;
            }
          }
        });
      });

      // Equalize heights when new items are added
      if (hasNewItems) {
        equalizeHeights(container);
      }
    });

    // Observe the container for new child elements
    observer.observe(container, {
      childList: true,
      subtree: true
    });

    heightObservers.set(container, observer);
  }

  function initSliders() {
    if (window.innerWidth >= 1200) {
      destroyAllSliders();
      return;
    }

    const containers = document.querySelectorAll('.tns-slider-container');
    
    containers.forEach(function (container) {
      // Skip if already initialized
      if (sliders.has(container)) return;
      if (container.classList.contains('tns-slider')) return;

      try {
        // For logo-list sections, disable fixedWidth; otherwise keep it
        const isLogoList = container.closest('.logo-list') !== null;
        const isAwardBadges = container.closest('.award-badges') !== null;
        const slider = tns({
          container: container,
          loop: true,
          gutter: 10,
          edgePadding: 50,
          items: 3,
          fixedWidth: (isLogoList || isAwardBadges) ? 200 : 250,
          center: true,
          controls: false,
          nav: false,
          mouseDrag: true,
          touch: true,
          responsive: {
            767: {
              items: 3,
              center: false,
              gutter: 20,
              fixedWidth: false,
              edgePadding: 0,
            },
            1024: {
              items: (isLogoList || isAwardBadges) ? 4 : 3,
              center: false,
              gutter: 20,
              fixedWidth: false,
              edgePadding: 0,
            },
          },
          onInit: function () {
            // Set up observer to watch for items and equalize heights instantly
            setupHeightObserver(container);
            // Equalize heights immediately after init
            equalizeHeights(container);
          },
          onIndexChanged: function () {
            equalizeHeights(container);
          },
        });

        sliders.set(container, slider);

        // Equalize heights on resize
        window.addEventListener('resize', function () {
          equalizeHeights(container);
        });
      } catch (error) {
        // Error initializing Tiny Slider instance
      }
    });
  }

  function destroyAllSliders() {
    sliders.forEach(function (slider, container) {
      try {
        slider.destroy();
      } catch (e) {
        // Ignore destroy errors
      }
      sliders.delete(container);

      // Disconnect height observer
      if (heightObservers.has(container)) {
        heightObservers.get(container).disconnect();
        heightObservers.delete(container);
      }
    });
  }

  // ============================
  // Industry Reviews & Info Cards
  // ============================

  function destroyInfoCardSliders() {
    infoCardSliders.forEach(function (slider, container) {
      try {
        slider.destroy();
      } catch (e) {
        // Ignore destroy errors
      }
      infoCardSliders.delete(container);

      if (heightObservers.has(container)) {
        heightObservers.get(container).disconnect();
        heightObservers.delete(container);
      }
    });
  }

  function destroyReviewSliders() {
    reviewSliders.forEach(function (slider, container) {
      try {
        slider.destroy();
      } catch (e) {
        // Ignore destroy errors
      }
      reviewSliders.delete(container);

      if (heightObservers.has(container)) {
        heightObservers.get(container).disconnect();
        heightObservers.delete(container);
      }
    });
  }

  function initReviewAndInfoSliders() {
    const containers = document.querySelectorAll('.industry-reviews__slider, .info-cards__grid');
    if (!containers.length) return;

    containers.forEach(function (container) {
      const isInfoCards = container.classList.contains('info-cards__grid');

      // Desktop always uses grid — slider is mobile/tablet only
      if (window.innerWidth >= 1024) return;

      // Stack-mode info cards don't use a slider — they just stack vertically
      if (isInfoCards && container.classList.contains('info-cards__grid--stack')) return;

      // Skip if already initialized
      if (container.classList.contains('tns-slider')) return;

      // Ensure there are child items
      const items = container.querySelectorAll('.slide, .industry-reviews__slide, .info-cards__item-wrapper');
      if (!items.length) return;

      const tabletItems = isInfoCards ? Math.min(2, parseInt(container.dataset.columns, 10) || 3) : 2;

      try {
        const slider = tns({
          container: container,
          loop: true,
          gutter: 15,
          items: 1,
          center: false,
          edgePadding: 30,
          controls: false,
          nav: false,
          mouseDrag: true,
          touch: true,
          speed: 500,
          slideBy: 1,
          responsive: {
            767: {
              items: 1,
              center: false,
              edgePadding: 40,
              gutter: 20,
              loop: true,
              slideBy: 1,
            },
          },
          onInit: function () {
            setupHeightObserver(container);
            equalizeHeights(container);

            const images = container.querySelectorAll('img');
            images.forEach(function (img) {
              if (img.complete) {
                equalizeHeights(container);
              } else {
                img.addEventListener('load', function () {
                  equalizeHeights(container);
                });
                img.addEventListener('error', function () {
                  equalizeHeights(container);
                });
              }
            });
          },
          onIndexChanged: function () {
            equalizeHeights(container);
          },
          onTransitionEnd: function () {
            equalizeHeights(container);
          },
        });

        reviewSliders.set(container, slider);
        if (isInfoCards) {
          infoCardSliders.set(container, slider);
          reviewSliders.delete(container);
        }

        window.addEventListener('resize', function () {
          equalizeHeights(container);
        });
      } catch (error) {
        // Error initializing shared slider for reviews/info-cards
      }
    });
  }

  // Initial run
  initSliders();
  initReviewAndInfoSliders();

  let resizeRequestId;
  window.addEventListener('resize', function () {
    if (resizeRequestId) {
      cancelAnimationFrame(resizeRequestId);
    }
    resizeRequestId = requestAnimationFrame(function () {
      // Logo/partner/award sliders: destroy at >= 1200px
      if (window.innerWidth < 1200) {
        initSliders();
      } else {
        destroyAllSliders();
      }

      // Review and info-card sliders: destroy at >= 1024px (desktop always uses grid), re-init at < 1024px
      initReviewAndInfoSliders();
      if (window.innerWidth >= 1024) {
        destroyInfoCardSliders();
        destroyReviewSliders();
      }
    });
  });
});
